export default () => {
  return {
    /**
     * Channel to subscribe to for token refreshing, goToOnline events
     */
    broadcastChannel: null,
    syncToOnlineLoader: false,
  };
};
